import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { DiscountsRouteNames, DiscountsRoutePathNames } from '../enums';
import { beforeEnter } from './guards/index';
import { createRoute } from './create/create';
import { listRoute } from './list/list';
import { updateRoute } from './update/update';

const RystIncentivesManager = () =>
  import('../components/ryst-incentives-manager/RystIncentivesManager.vue');

const rystIncentivesManagerRoute = {
  path: buildChildURL(DiscountsRoutePathNames.RYST_INCENTIVES_MANAGER),
  name: DiscountsRouteNames.RYST_INCENTIVES_MANAGER,
  component: RystIncentivesManager,
  beforeEnter: beforeEnter,
} as RouteRecordRaw;

// Register before `:id` (update) so this path is not matched as a discount id.
const childRoutes: RouteRecordRaw[] = [
  listRoute,
  createRoute,
  rystIncentivesManagerRoute,
  updateRoute,
];

export default childRoutes;
